var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    fillRule: "evenodd",
    d: "M7 14.502a.999.999 0 011.707-.707L12 17.088l3.293-3.293a.999.999 0 111.414 1.414L12 19.916l-4.707-4.707A.997.997 0 017 14.502zm0-5.001a1 1 0 001.707.708L12 6.915l3.293 3.294a1 1 0 001.414-1.415L12 4.087 7.293 8.794A.999.999 0 007 9.501",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E %3Cpath fill='%23231815' fill-rule='evenodd' d='M7 14.502c0-.256.098-.512.293-.707.39-.391 1.023-.391 1.414 0L12 17.088l3.293-3.293c.39-.391 1.023-.391 1.414 0 .39.391.39 1.023 0 1.414L12 19.916l-4.707-4.707c-.195-.195-.293-.451-.293-.707zM7 9.501c0 .256.098.513.293.708.39.39 1.023.39 1.414 0L12 6.915l3.293 3.294c.39.39 1.023.39 1.414 0 .39-.392.39-1.024 0-1.415L12 4.087 7.293 8.794C7.098 8.99 7 9.245 7 9.501' clip-rule='evenodd'/%3E %3C/svg%3E";
export { SvgIcMore as ReactComponent };